import React from 'react';
import { ArrowRight, Check, X } from 'lucide-react';
import { track } from 'meta-pixel';
export function ContentAndPricing() {
  return <section id="pricing" className="bg-white py-20 px-4 sm:px-6" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-20" data-id="element-3">
          {/* Left Column: What's Included */}
          <div className="space-y-8" data-id="element-4">
            <div data-id="element-5">
              <h3 className="text-3xl font-serif font-bold text-[#1B2A4A] mb-6" data-id="element-6">
                Lo que incluye (contenido exacto)
              </h3>
              <p className="text-gray-600 mb-6" data-id="element-7">
                No es teoría. Es un sistema de implementación inmediata.
              </p>
            </div>

            <ul className="space-y-4" data-id="element-8">
              {['Estructura de carpeta lista (Drive/Dropbox)', "Plantilla '00 Resumen' (1 página)", 'Lista de documentos por situación (sin sobreexponerte)', 'Historia financiera en 6 líneas (plantilla)', 'Guion de visita (qué decir / qué evitar)', 'Mensajes post-visita + seguimiento (copy/paste)', 'Sistema de tracking para postular sin quemarte', 'Plan de 72 horas + plan de 7 días'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-9">
                  <div className="mt-1 w-5 h-5 rounded-full bg-[#E6F4EA] flex items-center justify-center flex-shrink-0" data-id="element-10">
                    <Check className="w-3 h-3 text-green-600" data-id="element-11" />
                  </div>
                  <span className="text-gray-800" data-id="element-12">{item}</span>
                </li>)}
            </ul>

            <div className="pt-8 border-t border-gray-100" data-id="element-13">
              <h4 className="font-bold text-[#1B2A4A] mb-4" data-id="element-14">Para quién es:</h4>
              <ul className="space-y-2 mb-6" data-id="element-15">
                <li className="flex items-start gap-2 text-sm text-gray-600" data-id="element-16">
                  <Check className="w-4 h-4 text-[#C9A84C] mt-0.5" data-id="element-17" />
                  Buscas piso completo en ciudad competitiva
                </li>
                <li className="flex items-start gap-2 text-sm text-gray-600" data-id="element-18">
                  <Check className="w-4 h-4 text-[#C9A84C] mt-0.5" data-id="element-19" />
                  Estás cansado de perder por cosas "invisibles"
                </li>
                <li className="flex items-start gap-2 text-sm text-gray-600" data-id="element-20">
                  <Check className="w-4 h-4 text-[#C9A84C] mt-0.5" data-id="element-21" />
                  Quieres moverte rápido sin parecer desesperado
                </li>
              </ul>

              <h4 className="font-bold text-[#1B2A4A] mb-4" data-id="element-22">
                Para quién NO es:
              </h4>
              <ul className="space-y-2" data-id="element-23">
                <li className="flex items-start gap-2 text-sm text-gray-500" data-id="element-24">
                  <X className="w-4 h-4 text-gray-400 mt-0.5" data-id="element-25" />
                  Buscas "trucos" para mentir o falsificar
                </li>
                <li className="flex items-start gap-2 text-sm text-gray-500" data-id="element-26">
                  <X className="w-4 h-4 text-gray-400 mt-0.5" data-id="element-27" />
                  No tienes ningún ingreso/ahorro y esperas un milagro
                </li>
              </ul>
            </div>
          </div>

          {/* Right Column: Pricing Card */}
          <div className="relative" data-id="element-28">
            <div className="sticky top-8" data-id="element-29">
              <div id="pricing-card" className="bg-[#1B2A4A] rounded-2xl p-8 text-center text-white shadow-2xl relative overflow-hidden border border-[#C9A84C]/30" data-id="element-30">
                {/* Badge */}
                <div className="absolute top-0 right-0 bg-[#C9A84C] text-[#1B2A4A] text-xs font-bold px-4 py-1.5 rounded-bl-xl" data-id="element-31">
                  OFERTA DE LANZAMIENTO
                </div>

                <h3 className="text-2xl font-serif font-bold mb-2" data-id="element-32">
                  Carpeta de Alquiler Imposible
                </h3>
                <p className="text-gray-400 text-sm mb-6" data-id="element-33">Edición España</p>

                {/* Discount Badge */}
                <div className="inline-flex items-center gap-2 bg-red-500/20 border border-red-400/30 rounded-full px-4 py-1.5 mb-6" data-id="element-34">
                  <span className="text-red-300 font-bold text-sm" data-id="element-35">
                    🔥 68% de descuento
                  </span>
                </div>

                <div className="flex items-center justify-center gap-3 mb-2" data-id="element-36">
                  <span className="text-2xl text-gray-500 line-through font-medium" data-id="element-37">
                    29€
                  </span>
                  <span className="text-5xl font-bold text-[#C9A84C]" data-id="element-38">
                    6,39€
                  </span>
                </div>
                <p className="text-gray-400 text-sm mb-8" data-id="element-39">Pago único</p>

                <p className="text-gray-300 text-sm mb-8 px-4" data-id="element-40">
                  Si pierdes 2–3 semanas más por candidatura caótica, lo pagas
                  en estrés, tiempo y oportunidades.
                </p>

                <div data-id="element-41">
                  <a href="https://editorialnexo.com/cart/61085422223690:1" className="group relative block" onClick={() => {
                  if (window.fbq) {
                    window.fbq('track', 'AddToCart', {
                      content_name: 'Carpeta de Alquiler Imposible',
                      content_type: 'product',
                      value: 6.39,
                      currency: 'EUR'
                    });
                  }
                }} data-id="element-42">
                    <div className="absolute -inset-1 bg-[#C9A84C]/30 rounded-xl blur-lg group-hover:bg-[#C9A84C]/50 transition-all duration-500" data-id="element-43"></div>
                    <div className="cta-shimmer relative w-full text-[#1B2A4A] font-extrabold py-5 rounded-xl text-lg transition-all transform hover:-translate-y-1.5 hover:scale-[1.03] flex items-center justify-center gap-3 tracking-tight mb-4" data-id="element-44">
                      DESCARGAR AHORA · 6,39€
                    </div>
                  </a>

                  <div className="text-xs text-gray-400 space-y-2" data-id="element-45">
                    <p data-id="element-46">🔒 Pago seguro vía Stripe</p>
                    <p data-id="element-47">📥 Acceso inmediato al material</p>
                  </div>
                </div>

                {/* Guarantee/Trust */}
                <div className="mt-6 text-center" data-id="element-48">
                  <div className="inline-flex items-center gap-2 bg-[#FDF8EE] px-4 py-2 rounded-full border border-[#C9A84C]/20" data-id="element-49">
                    <span className="text-[#1B2A4A] font-medium text-sm" data-id="element-50">
                      Sistema probado en Madrid y BCN
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}